import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './styles.css';

const HelpLink = ({ idPrefix, parentMenu, messageId, messageDefault }) => (
  <a
    href="https://docs.powerschool.com/CCRVHC"
    target="_blank"
    rel="noopener noreferrer"
    id={`js-${idPrefix}-help-menu-link`}
    className="item"
    styleName={`${parentMenu ? 'responsive-display' : ''}`}
  >
    <FormattedMessage id={messageId} defaultMessage={messageDefault} />
  </a>
);

HelpLink.propTypes = {
  idPrefix: PropTypes.string,
  parentMenu: PropTypes.string,
  messageId: PropTypes.string,
  messageDefault: PropTypes.string,
  current: PropTypes.shape({
    viewer: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  current: state.current,
});

export default connect(mapStateToProps)(HelpLink);
